import { getJsonResult, httpGet } from './server-wrapper'
import wx from 'weixin-js-sdk'

const weixin = /MicroMessenger/i.test(navigator.userAgent)
const isIos = /(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent)
const cache = new Map()
let initialUrl

export function prepare (Vue) {
  Vue.config.ignoredElements = ['wx-open-launch-weapp', 'wx-open-launch-app']
  if (!weixin) {
    return
  }
  if (isIos) {
    initialUrl = window.location.href
  }
}

export function isWeixin () {
  return weixin
}

export async function getJsTicket ({ jsApiList = [], openTagList = [] }, shareData = null) {
  if (!weixin) {
      return new Promise(function(_, reject) {
          reject('请在微信中打开')
      })
  }

  let url = window.location.href
  if (isIos && initialUrl) {
    url = initialUrl
  }
  url = encodeURIComponent(url)

  let config
  if (cache.has(url)) {
    config = cache.get(url)
  } else {
    config = await getJsonResult('/weixin/js-ticket?url=' + url)
  }
  cache.set(url, config)

  if (jsApiList.length > 0) {
    config.jsApiList = jsApiList
  }
  if (openTagList.length > 0) {
    config.openTagList = openTagList
  }
  // config.debug = true
  wx.config(config)

  return new Promise(function (resolve, reject) {
    wx.ready(function () {
      console.log('weixin loaded for', url)
      if (shareData != null) {
        console.log('shareData:', shareData)
        wx.updateAppMessageShareData({
          title: shareData.title,
          desc: shareData.desc,
          link: shareData.url,
          imgUrl: shareData.image,
          success: function () {
          }
        })

        wx.updateTimelineShareData({
          title: shareData.title,
          desc: shareData.desc,
          link: shareData.url,
          imgUrl: shareData.image
        })
      }
      resolve()
    })
    wx.error(function ({ errMsg }) {
      console.log('网站微信认证失败', errMsg)
      // alert('网站微信认证失败' + errMsg)
      reject(errMsg)
    })
  })
}

export function showOptionMenu () {
  wx.showOptionMenu()
}

export function hideOptionMenu () {
  wx.hideOptionMenu()
}

export function scanQRCode (option) {
  option = Object.assign(
    {
      needResult: 1
    },
    option
  )
  return new Promise(function (resolve, reject) {
    wx.scanQRCode({
      needResult: option.needResult,
      scanType: ['qrCode', 'barCode'],
      success: function ({ resultStr, errMsg }) {
        console.log('qrcode', resultStr, errMsg)
        if (errMsg === 'scanQRCode:ok') {
          resolve(resultStr)
        } else {
          reject(errMsg)
        }
      }
    })
  })
}

export function downloadAndGetWxMediaUrl (serverId, fileName) {
  let url = '/weixin/downloadAndGetWxMediaUrl?serverId=' + serverId
  if (fileName) {
    url += '&name=' + fileName
  }
  return httpGet(url)
}

export function wxLaunch (info) {
  const btn = document.getElementById(info.eleId) // 获取元素
  if (isWeixin()) {
    if (isVersion()) {
      const script = document.createElement('script')// 创建script内容插槽 避免template标签冲突
      script.type = 'text/wxtag-template' // 使用script插槽 必须定义这个type
      script.text = info.content // 自定义的html字符串内容
      const html = `<wx-open-launch-weapp style="width:100%;display:block;" env-version="${info.ver}" appid="${info.appid}" path="${info.url}">${script.outerHTML}</wx-open-launch-weapp>`
      btn.innerHTML = html // html字符串赋值
      // 点击按钮 正常跳转触发
      btn.addEventListener('launch', function (e) {
        console.log('success')
        const url = window.location.href
        console.log('初始化微信sdk完成：' + url)
        if(url == 'https://m.zhinengma.cn/showText?id=BRoXIXizh3C'){
          btn.click()
        }
      })
      // 点击跳转 抛出异常
      btn.addEventListener('error', function (e) {
        console.log('fail', e.detail)
        alert(`跳转异常 - ${e.detail}`)
      })
    } else {
      btn.innerHTML = info.content
      const linkBtn = document.getElementById('launch-btn') // 获取元素
      linkBtn.addEventListener('click', function (e) {
        alert('该版本不支持打开小程序')
      })
    }
  } else {
    btn.innerHTML = info.content
    const linkBtn = document.getElementById('launch-btn') // 获取元素
    linkBtn.addEventListener('click', function (e) {
      alert('该浏览器不支持打开小程序')
    })
  }
}

function isVersion () {
  let client = false // 当前版本号是否支持 (默认不支持)
  const wxInfo = navigator.userAgent.match(/MicroMessenger\/([\d\.]+)/i) // 微信浏览器信息
  // 微信版本号 wxInfo[1] = "7.0.18.1740" (示例)
  // 进行split转成数组进行判断 [7,0,18,1740] (示例)
  console.log(wxInfo)
  const version = wxInfo[1].split('.')
  // 判断版本在7.0.12及以上的版本
  if (version[0] >= 7) {
    if (version[1] >= 0) {
      if (version[2] >= 12) {
        client = true // 当前版本支持
      }
    }
  }
  return client
}



// WEBPACK FOOTER //
// ./src/utils/weixin.js